/**
 * UA-based device detection. Used by the magic-link chooser to decide
 * whether to render the Open-in-app / Continue-on-web / Download-app
 * interstitial. Not for security decisions — UA strings are spoofable.
 */

const getUserAgent = (): string => {
    if (typeof navigator === 'undefined') return ''
    return navigator.userAgent || ''
}

// Since iPadOS 13, Safari on iPad defaults to "Request Desktop Website" and
// reports `Macintosh` in the UA. The maxTouchPoints check distinguishes those
// iPads from real Macs (which report 0). Without this, iPad users on default
// Safari would hit the desktop branch and lose the "Open in Sama app" path.
const isIPadOSDesktopMode = (): boolean =>
    typeof navigator !== 'undefined' &&
    /Macintosh/i.test(getUserAgent()) &&
    navigator.maxTouchPoints > 1

export const isIOS = (): boolean =>
    /iPhone|iPad|iPod/i.test(getUserAgent()) || isIPadOSDesktopMode()

export const isAndroid = (): boolean => /Android/i.test(getUserAgent())

export const isMobileDevice = (): boolean => isIOS() || isAndroid()
